"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactRouterDom = require("react-router-dom");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _styleHelper = require("../styleHelper2");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();
var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};
const AnchorLink = (0, _styledComponents.default)(_reactRouterDom.Link).withConfig({
  displayName: "AnchorLink",
  componentId: "sc-1lxgkcm-0"
})(["text-decoration:none;cursor:pointer;color:", ";", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", ""], props => props.theme.primary.normal, (0, _styleHelper.display)(), (0, _styleHelper.dimension)(), (0, _styleHelper.position)(), (0, _styleHelper.padding)(), (0, _styleHelper.margin)(), (0, _styleHelper.background)(), (0, _styleHelper.flexParent)(), (0, _styleHelper.flexChild)(), (0, _styleHelper.font)(), (0, _styleHelper.animation)(), (0, _styleHelper.border)());
const _default = AnchorLink;
var _default2 = exports.default = _default;
;
(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;
  if (!reactHotLoader) {
    return;
  }
  reactHotLoader.register(AnchorLink, "AnchorLink", "/Users/jake.clayton/frontend/ls-common-client/src/components/AnchorLink.js");
  reactHotLoader.register(_default, "default", "/Users/jake.clayton/frontend/ls-common-client/src/components/AnchorLink.js");
})();
;
(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();